import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button, CTA, PageHero, Reveal, SectionIntro, useSeo } from "../components/Shared";
import { IMG } from "../data/content";

const FORMATS = ["Professional courses", "Skill-based training", "Internships", "Workshops", "Seminars & bootcamps", "Corporate training"];

export default function Education() {
  useSeo(
    "Education & Programs | Dishan International Group",
    "A practical learning ecosystem for students, professionals and founders, courses, training, workshops and the Dishan Leadership Program."
  );
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 80);
    }
  }, [hash]);

  return (
    <>
      <PageHero
        eyebrow="Education & experience"
        titleKey="education.hero.title" title="Learn with purpose. Lead with confidence."
        subtitleKey="education.hero.subtitle" subtitle="A practical learning ecosystem for students, professionals, founders and organizations building capability for what comes next."
      />
      <main>
        <section className="section">
          <div className="container">
            <div className="image-split">
              <Reveal className="image-split-media"><img src={IMG.education} alt="Learning workshop in progress" loading="lazy" /></Reveal>
              <Reveal delay={0.1}>
                <span className="eyebrow">Ways to learn</span>
                <h2>Experience is part of the curriculum.</h2>
                <p>Choose the format that fits your ambition, then make it real through practice, reflection and meaningful exposure.</p>
                <Button to="/internship" variant="secondary">Apply for an Internship</Button>
              </Reveal>
            </div>
            <div className="career-grid">
              {FORMATS.map((x, i) => (
                <Reveal key={x} delay={(i % 3) * 0.06} className="career-card">
                  <span>0{i + 1}</span>
                  <h3>{x}</h3>
                  <p>Structured, practical and designed to move beyond theory.</p>
                  <Link to={x === "Internships" ? "/internship" : "/contact"} className="text-link" data-testid={`education-${i + 1}-link`}>Explore <ArrowRight size={14} /></Link>
                </Reveal>
              ))}
            </div>
          </div>
        </section>
        <section className="section navy" id="dlp">
          <div className="container dlp">
            <Reveal>
              <span className="eyebrow on-dark">Featured programme · DLP</span>
              <h2>Dishan Leadership Program</h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="large-copy">A focused pathway for people who want to understand leadership as a practice, not a title.</p>
              <div className="dlp-points">
                <span>Who can apply <b>Students · professionals · founders</b></span>
                <span>Mode <b>Blended / cohort-based</b></span>
                <span>Learning domains <b>Leadership · brand · business</b></span>
                <span>Outcome <b>Certification & career exposure</b></span>
              </div>
              <Button variant="ghost">Explore DLP</Button>
            </Reveal>
          </div>
        </section>
        <CTA />
      </main>
    </>
  );
}
